/* eslint-disable no-unused-vars */
import axios from "axios";
import moment from "moment";
import { apiServerUrl } from '../../config/config.json';

const url = `${apiServerUrl}/office_groups`;

const state = {
  office_groups: [],
  assigned_offices: [],
  unassigned_offices: [],
  officeGroupCount: null,
};

const getters = {
  allOfficeGroups: (state) => state.office_groups,
  getAssignedGroupOffices: (state) => state.assigned_offices,
  getUnassignedGroupOffices: (state) => state.unassigned_offices,
  totalOfficeGroupCount: (state) => state.officeGroupCount,
};

const actions = {
  async fetchOfficeGroups({ commit }, payload) {
    const page = payload.page || 1;
    let limit = payload.itemsPerPage;

    try {
      
      const url1 = url + "?page=" + page + "&limit=" + limit;
      const authToken = localStorage.getItem("access_token");
      const response = await axios.get(url1, {
        headers: { "x-drmms-token": authToken },
      });
      // let groups = response.data.rows.map((group) => ({
      //     ...group,
      //     date: moment(group.createdAt).format('LLL'),
      // }));
      let groups = {
        count: response.data.count,
        rows: response.data.rows.map((group) => ({
          ...group,
          date: moment(group.createdAt).format("LLL"),
        })),
      };
      commit("setOfficeGroups", groups);
    } catch (err) {
      console.log(err);
    }
  },
  async createOfficeGroup({ commit }, body) {
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.post(url, body, {
        headers: { "x-drmms-token": authToken },
      });
      let newGroup = Object.assign(response.data, {
        date: moment(response.data.createdAt).format("LLL"),
      });
      commit("newOfficeGroup", newGroup);
    } catch (err) {
      console.log(err);
    }
  },
  async deleteOfficeGroup({ commit }, group_ids) {
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios({
        method: "delete",
        url,
        headers: { "x-drmms-token": authToken },
        data: { group_ids },
      });
      // const response = await axios.delete(`${url}`, {
      //     headers: { 'x-drmms-token': authToken }
      // });
      commit("removeOfficeGroup", group_ids);
      return response;
    } catch (err) {
      console.log(err);
    }
  },
  async updateOfficeGroup({ commit }, body) {
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios({
        method: "put",
        url: `${url}/${body.id}`,
        headers: { "x-drmms-token": authToken },
        data: {
          name: body.name,
          description: body.description,
        },
      });
      commit("updateOfficeGroup", body);
      return true;
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400)
          return { error: true, status: 400, message: err.response.data };
        else if (err.response.status == 400)
          return { error: true, status: 500, message: "Internal Server Error" };
      }
      console.log(err);
    }
  },
  async fetchUnassignedGroupOffices({ commit }, body) {
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.post(`${url}/unassignedOffices`, body, {
        headers: { "x-drmms-token": authToken },
      });
      state.assigned_offices = body.offices.map((office) => ({
        ...office,
        isAssigned: true,
      }));

      let unassigned = response.data.map((office) => ({
        ...office,
        isAssigned: false,
      }));
      commit("setUnassignedGroupOffices", unassigned);
    } catch (err) {
      console.log(err);
    }
  },
  groupAddOffice({ commit }, item) {
    commit("addOffice", item);
  },
  groupRemoveOffice({ commit }, item) {
    commit("removeOffice", item);
  },
  async saveGroupOfficeAssignment({ commit }, id) {
    let add_offices = state.assigned_offices.filter(
      (checkOffice) => checkOffice.isAssigned === false
    );
    let delete_offices = state.unassigned_offices.filter(
      (checkOffice) => checkOffice.isAssigned === true
    );

    let body = {
      group_id: id,
      add: add_offices,
      delete: delete_offices,
    };

    try {
      const authToken = localStorage.getItem("access_token");
      let response = await axios({
        method: "put",
        url: `${url}/assignOffices`,
        headers: { "x-drmms-token": authToken },
        data: body,
      });
      commit("updateOffices", id);
      return true;
    } catch (err) {
      if (err.response)
        return { error: true, status: 500, message: "Internal Server Error" };
      console.log(err);
    }
  },
};

const mutations = {
  setOfficeGroups: (state, office_groups) => {
    state.office_groups = office_groups.rows;
    state.officeGroupCount = office_groups.count;
  },
  newOfficeGroup: (state, office_group) =>
    state.office_groups.push(office_group),
  removeOfficeGroup: (state, id) => {
    for (let i = 0; i < id.length; i++) {
      state.office_groups = state.office_groups.filter(
        (office_group) => office_group.id !== id[i]
      );
    }
  },
  updateOfficeGroup: (state, updGroup) => {
    const index = state.office_groups.findIndex(
      (group) => group.id === updGroup.id
    );
    if (index !== -1) {
      state.office_groups.splice(index, 1, updGroup);
    }
  },
  setUnassignedGroupOffices: (state, offices) =>
    (state.unassigned_offices = offices),
  addOffice: (state, office) => {
    state.assigned_offices.push(office);
    state.unassigned_offices = state.unassigned_offices.filter(
      (checkOffice) => checkOffice.id !== office.id
    );
  },
  removeOffice: (state, office) => {
    state.unassigned_offices.push(office);
    state.assigned_offices = state.assigned_offices.filter(
      (checkOffice) => checkOffice.id !== office.id
    );
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
